export default {
	title: '<h1>100%<span>&nbsp;Risk</span><p>&nbsp;Free</p></h1>',
	free: {
		banner_text: 'https://web-data.zmlearn.com/image/6a3bNYM5NmU5gJZr22Sfgu/slogan%402x.png',
		button: 'https://web-data.zmlearn.com/image/8jDaAArHya9Xz1BrJww9fd/btn_home_banner%402x.png',
	},
	lesson: {
		title: 'Kids Classes',
		list: [
			[
				{
					id: 1,
					img: 'https://web-data.zmlearn.com/image/eFYKAyxndUFxwSDQabgrfb/en-1.png',
				},
				{
					id: 2,
					img: 'https://web-data.zmlearn.com/image/9Qr1GkE7WGw5mGWqjRKTzm/en-2.png',
				},
				{
					id: 3,
					img: 'https://web-data.zmlearn.com/image/wAUUqWWs3XgKuD2wi8RpL3/en-3.png',
				},
				{
					id: 4,
					img: 'https://web-data.zmlearn.com/image/scHyHrRESQzRxux4dRUBeJ/en-4.png',
				},
			],
			[
				{
					id: 1,
					img: 'https://web-data.zmlearn.com/image/dWr2FwsMCdGYbrVuMBQ5zx/Ma-1.png',
				},
				{
					id: 2,
					img: 'https://web-data.zmlearn.com/image/sRZnUrbkw7d4ekmUtugWav/Ma-2%402x.png',
				},
				{
					id: 3,
					img: 'https://web-data.zmlearn.com/image/eQmFqsD1pFVJks5HaUFGay/Ma-3.png',
				},
				{
					id: 4,
					img: 'https://web-data.zmlearn.com/image/sBzkJM1NXfsAMhecdudZjw/Ma-4.png',
				},
			],
		],
		buttons: [
			'https://web-data.zmlearn.com/image/x7unq2yWKjxXcJxJrJbYN2/%E8%8B%B1%E8%AF%AD%402x.png',
			'https://web-data.zmlearn.com/image/dqFJ4NmmwCUyEutZm5GfTT/%E6%95%B0%E5%AD%A6%402x.png',
		],
	},
	curriculum: {
		title: 'A comprehensive curriculum system',
		list: [
			{
				id: 1,
				img: 'https://web-data.zmlearn.com/image/tsak4vGmRrG8RJ6DZpqsUq/%E8%8B%B1%E8%AF%AD%402x(1).png',
				pImg: 'https://web-data.zmlearn.com/image/prKBnS41cEXrPtVquphEVF/%E8%8B%B1%E8%AF%AD-%E5%9B%BE%402x%202.png',
			},
			{
				id: 2,
				img: 'https://web-data.zmlearn.com/image/aQZGxmVkqjWHam23eFYWVv/F02E53D8-00C9-47E8-8AAA-CD98619738AE.png',
				pImg: 'https://web-data.zmlearn.com/image/6tLF1UZvgVWHe1GAnwnYsd/37A8582C-7069-4986-96A9-B78BF8A26D16.png',
			},
		],
	},
	growth: {
		title: 'Growth System',
		list: [
			{
				id: 1,
				img: 'https://web-data.zmlearn.com/image/gtF16Zjy69AGWK6sKi6hyy/%E8%AF%BE%E7%A8%8B-english%402x.png',
			},
			{
				id: 2,
				img: 'https://web-data.zmlearn.com/image/gmps7AY9eH8roT6eMnp6yX/%E8%AF%BE%E7%A8%8B-Math%402x.png',
			},
		],
	},
	outcome: {
		title: 'Learning Outcome',
		en: `<h4><span>5 Features </span>of<p> English</p></h4>`,
		math: `<h4><span>6 Features </span>of<p style={{ color: '#32C095' }}> Math</p></h4>`,
		list: [
			[
				{
					id: 1,
					title: 'Vocabulary',
					span: '600+ ',
					context: 'High-Frequency Vocabularies',
					img: 'https://web-data.zmlearn.com/image/9srJHHEkVZysd8DGzFSKyY/EN-1-icon%402x.png',
				},
				{
					id: 2,
					title: 'Speaking',
					span: '85+ ',
					context: 'Sentence Structure',
					img: 'https://web-data.zmlearn.com/image/g5izC2PySdAZvU2pv6WZb6/EN-2-icon%402x.png',
				},
				{
					id: 3,
					title: 'Reading',
					span: '15+ ',
					context: 'Reading Strategy',
					img: 'https://web-data.zmlearn.com/image/mWMrMpBirLXz85vMecSsAR/EN-3-icon%402x.png',
				},
				{
					id: 4,
					title: 'Grammar',
					span: '75+ ',
					context: 'Grammar Rules',
					img: 'https://web-data.zmlearn.com/image/qLUVyti4JZZGy95wz1pzd8/EN-4-icon%402x.png',
				},
				{
					id: 5,
					title: 'Writing',
					span: '30+ ',
					context: 'Writing skills',
					img: 'https://web-data.zmlearn.com/image/xXABu4tFbFEarF3qvNBvo/EN-5-icon%402x.png',
				},
			],
			[
				{
					id: 1,
					title: 'Number',
					span: '',
					context: 'Including place value, calculation and fractions.',
					img: 'https://web-data.zmlearn.com/image/sY16jqTBYxGBLVyLUjLWnG/Math-1-icon%402x.png',
				},
				{
					id: 2,
					title: 'Rules of Number',
					span: '',
					context: 'Grasp of Addition, Subtraction, Multiplication and Division.',
					img: 'https://web-data.zmlearn.com/image/iu1eX55fXiWT1KbyEkMedo/Math-2-icon%402x.png',
				},
				{
					id: 3,
					title: 'Measurement',
					span: '',
					context: 'Choose and use appropriate standard units to estimate and measuret.',
					img: 'https://web-data.zmlearn.com/image/9K7wtLaBueedEGTJ8iSxdj/Math-3-icon%402x.png',
				},
				{
					id: 4,
					title: 'Geometry',
					span: '',
					context: 'Read and write names for shapes, identify and describe the properties of shapes.',
					img: 'https://web-data.zmlearn.com/image/aHzvusTWtxGBS2ouzDciLe/Math-4-icon%402x.png',
				},
				{
					id: 5,
					title: 'Statistics',
					span: '',
					context: 'Be able to describe a large amount of data simply either pictorially or numerically.',
					img: 'https://web-data.zmlearn.com/image/oLA63jVaf3Ufo3c3nXxWRY/Math-5-icon%402x.png',
				},
				{
					id: 6,
					title: 'Fractions',
					span: '',
					context: 'Grasp the concept of fractions, be able to simplify a fraction and compare fractions.',
					img: 'https://web-data.zmlearn.com/image/aUtJb96nyXSS5ZWAbtsVhE/Math-6-icon%402x.png',
				},
			],
		],
	},
	comments: {
		title: 'Real voice from parents',
		list: [
			{
				id: 1,
				name: `Amy's mom`,
				content: `My child really likes this interesting learning mode. Every lesson he is always interested and engaged. Also it develops his habit of independent learning. l used to find it difficult that make my kid loving studying. This product surprised me.`,
				icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
				img: 'https://web-data.zmlearn.com/image/gPExCEpox63YkuKnT5aghf/Amymom%402x.png',
			},
			{
				id: 2,
				name: `Cindy's mom`,
				content: `The best thing about this course is that the child has got rid of the vocabulary re-coding problem and his pronunciation is now standard and pure and he is becoming more confident and willing to speak English in class.`,
				icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
				img: 'https://web-data.zmlearn.com/image/s35Anxhhhw2AS4MBXefeM1/cindymom%402x.png',
			},
			{
				id: 3,
				name: `James's father`,
				content: `Happy maths course is much more fun than I thought.  He likes to sharing what he learnt during his class to his mom and I, sometimes we even can't answer correctly.  And I can feel that he is more confident now,  we're so proud! `,
				icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
				img: 'https://web-data.zmlearn.com/image/pWCmcvCkGTvwwoKMJgVEzx/Jamesfather%402x.png',
			},
		],
	},
};
